export enum TrackingEvent {
  ClosedCollapsibleSection = `Closed collapsible section`,
  OpenedCollapsibleSection = `Opened collapsible section`,
}
